import { Component, EventEmitter, OnInit } from '@angular/core';
import { Account } from '../../../../model/Account';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AccountPageService } from '../../../../service/account-page.service';
import { DarkModeService } from '../../../../service/dark-mode.service';

@Component({
  selector: 'ch-update-account',
  templateUrl: './update-account.component.html'
})
export class UpdateAccountComponent implements OnInit {

  account: Account;
  updateAccountForm: UntypedFormGroup;
  accountUpdateEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly fb: UntypedFormBuilder,
              private readonly toastrService: ToastrService,
              public readonly darkModeService: DarkModeService,
              private readonly accountService: AccountPageService,
              public readonly modalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.updateAccountForm = this.fb.group({
      id: new UntypedFormControl({value: this.account.id, disabled: true}),
      name: new UntypedFormControl(this.account.name),
      emailAddresses: new UntypedFormControl(this.account.emailAddresses),
      reportEmailAddresses: new UntypedFormControl(this.account.reportEmailAddresses)
    });
  }

  update() {
    this.accountService.updateAccount(this.updateAccountForm.getRawValue()).subscribe(() => {
      this.modalRef.hide();
      this.accountUpdateEvent.emit();
    }, err => {
      console.log(err);
      this.toastrService.error(err.error);
    });
  }

}
